import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnChanges {
    @Input() count: number;
    @Input() pageSize: number;
    @Input() currentPage = 1;
    @Input() maxSize = 7;
    @Output() pageChanged = new EventEmitter<number>();

    collectionSize: number;

    constructor() {
        this.pageChanged.emit(this.currentPage);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.count || changes.pageSize) {
            this.collectionSize = this.count || 0;
        }
    }

    onPageChange(page: number) {
        this.currentPage = page;
        this.pageChanged.emit(page);
    }
}
